// @ts-nocheck
export interface ModuleConfig {
  id: string;
  name: string;
  description?: string;
  version: string;
  icon?: string;
  category?: 'content' | 'commerce' | 'communication' | 'utility';
  dependencies?: string[];
  tables?: string[];
}

export interface RouteDefinition {
  path: string;
  component: () => Promise<{ default: React.ComponentType }>;
  permission?: string;
  label: string;
  icon?: string;
}

export interface ModuleDefinition extends ModuleConfig {
  adminRoutes?: RouteDefinition[];
  hooks?: {
    onInstall?: (siteId: string) => Promise<void>;
    onUninstall?: (siteId: string) => Promise<void>;
    onSettingsUpdate?: (siteId: string, settings: any) => Promise<void>;
  };
}

class ModuleRegistry {
  private modules = new Map<string, ModuleDefinition>();

  register(mod: ModuleDefinition) {
    if (this.modules.has(mod.id)) {
      console.warn(`Module ${mod.id} already registered`);
      return;
    }
    this.modules.set(mod.id, mod);
  }

  get(id: string): ModuleDefinition | undefined {
    return this.modules.get(id);
  }

  getAll(): ModuleDefinition[] {
    return Array.from(this.modules.values());
  }

  getActive(activeIds: string[]): ModuleDefinition[] {
    return activeIds
      .map(id => this.modules.get(id))
      .filter((m): m is ModuleDefinition => Boolean(m));
  }

  getRoutes(activeIds: string[]): RouteDefinition[] {
    return this.getActive(activeIds).flatMap(mod => mod.adminRoutes || []);
  }
}

export const moduleRegistry = new ModuleRegistry();
